import { Promotion } from '@teko/ecommerce';
import { Col, Currency, styled } from '@teko/ds-desktop';
import { ProductPrice } from '@teko/teko-ecommerce';

export const Wrapper = styled.div``;

export const Divider = styled.div`
  border-bottom: 1px dashed #e0e0e0;
  margin: 1rem 0;
`;

export const ProductVariantsWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
`;

export const FreeShipping = styled.div`
  color: #53c305;
  display: flex;
  align-items: center;
`;
export const ShippingInfo = styled.div`
  margin-left: 8px;
`;

export const Label = styled.div(
  ({ theme }) => `
  color: ${theme.colors.textSecondary};
  font-size: 0.875rem;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`,
);

export const BundleProductWrapper = styled.a`
  display: flex;
  align-items: center;

  font-size: 0.75rem;
  color: #333333;
  text-decoration: none;
  margin-top: 1rem;
  cursor: pointer;
`;
export const BundleImage = styled.div`
  width: 10%;
  border-radius: 2px;
  border: solid 1px #e0e0e0;
`;
export const BundleProductName = styled.div`
  margin-left: 18px;
  width: 70%;

  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
export const BundlePrice = styled.div`
  font-weight: 500;
  flex: 1;
  text-align: right;
`;

export const ComboTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
`;

export const StyledPromotion = styled(Promotion)`
  width: 100%;
  margin-top: 0.5rem;
  border-radius: 0.5rem;
`;

export const RelatedPromotions = styled.div`
  li {
    margin-bottom: 7px;
  }
`;
export const Title = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
`;

export const StyledCurrency = styled(Currency)`
  color: #ed2101;
  font-weight: 500;
`;

export const Link = styled.a`
  text-decoration: none;
  margin-left: 4px;
`;
export const DescriptionCol = styled(Col)`
  padding-left: 0 !important;
`;

export const StyledProductPrice = styled(ProductPrice)`
  margin-bottom: 12px;
`;

export const Stock = styled.div`
  color: #f78212;
  font-size: 0.75rem;
  margin: 0 0 0.5rem 0;
`;

export const ModalAction = styled.div`
  text-align: center;
`;

export const StyledProductNotes = styled.div`
  border: solid 1px #f78212;
  border-radius: 4px;
  color: #f78212;
  padding: 10px 15px 0px 15px;
  margin-top: 25px;
  ol {
    padding-left: 10px;
    margin-bottom: 10px;
  }
  font-size: 12px;
`;

export const WarningNote = styled.div`
  margin-top: 16px;
  border: solid 1px #f78212;
  border-radius: 4px;
  color: #f78212;
  padding: 6px 8px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  .text {
    flex: 1;
    margin-left: 6px;
    line-height: 1.5;
  }
`;

export const DetailService = styled.a`
  margin-left: 2rem;
`;

export const DefaultPromo = styled.div`
  margin-top: 16px;
`;

export const DefaultPromoContent = styled.div`
  background-color: #fbfbfd;
  border: 1px solid #e4e5f0;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 8px 16px;
  margin-top: 8px;
`;

export const NotFoundProductLayout = styled.div`
  min-height: 450px;
`;

export const Content = styled.div`
  padding: 1rem;
  line-height: 1.5rem;
  h2 {
    font-size: 20px;
    line-height: 1.4;
  }
  h3 {
    font-size: 16px;
    line-height: 1.3;
  }
  h4 {
    font-size: 14px;
  }
  h5 {
    font-size: 12px;
  }
  h6 {
    font-size: 10px;
  }
  img {
    height: auto;
  }

  > * {
    max-width: 100%;
  }
`;
